/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	function webpackJsonpCallback(data) {
/******/ 		var chunkIds = data[0];
/******/ 		var moreModules = data[1];
/******/ 		var executeModules = data[2];
/******/
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(data);
/******/
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 		// add entry modules from loaded chunk to deferred list
/******/ 		deferredModules.push.apply(deferredModules, executeModules || []);
/******/
/******/ 		// run deferred modules when all chunks ready
/******/ 		return checkDeferredModules();
/******/ 	};
/******/ 	function checkDeferredModules() {
/******/ 		var result;
/******/ 		for(var i = 0; i < deferredModules.length; i++) {
/******/ 			var deferredModule = deferredModules[i];
/******/ 			var fulfilled = true;
/******/ 			for(var j = 1; j < deferredModule.length; j++) {
/******/ 				var depId = deferredModule[j];
/******/ 				if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 			}
/******/ 			if(fulfilled) {
/******/ 				deferredModules.splice(i--, 1);
/******/ 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 			}
/******/ 		}
/******/
/******/ 		return result;
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 	// Promise = chunk loading, 0 = chunk loaded
/******/ 	var installedChunks = {
/******/ 		11: 0
/******/ 	};
/******/
/******/ 	var deferredModules = [];
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
/******/ 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
/******/ 	jsonpArray.push = webpackJsonpCallback;
/******/ 	jsonpArray = jsonpArray.slice();
/******/ 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
/******/ 	var parentJsonpFunction = oldJsonpFunction;
/******/
/******/
/******/ 	// add entry module to deferred list
/******/ 	deferredModules.push([440,1,0]);
/******/ 	// run deferred modules when ready
/******/ 	return checkDeferredModules();
/******/ })
/************************************************************************/
/******/ ({

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28);
module.exports = __webpack_require__(462);


/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 462:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var getters_namespaceObject = {};
__webpack_require__.r(getters_namespaceObject);
__webpack_require__.d(getters_namespaceObject, "currentDeviceHandle", function() { return currentDeviceHandle; });
__webpack_require__.d(getters_namespaceObject, "currentDeviceColor", function() { return currentDeviceColor; });
var mutations_namespaceObject = {};
__webpack_require__.r(mutations_namespaceObject);
__webpack_require__.d(mutations_namespaceObject, "setBackplates", function() { return setBackplates; });
__webpack_require__.d(mutations_namespaceObject, "setBumpers", function() { return setBumpers; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.symbol.async-iterator.js
var es7_symbol_async_iterator = __webpack_require__(13);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.symbol.js
var es6_symbol = __webpack_require__(14);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__(8);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.promise.js
var es6_promise = __webpack_require__(9);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__(7);

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(10);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find-index.js
var es6_array_find_index = __webpack_require__(91);

// EXTERNAL MODULE: ./resources/styles/pages/page.collab.scss
var page_collab = __webpack_require__(441);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(1);

// EXTERNAL MODULE: ./resources/components/PageNav.vue + 4 modules
var PageNav = __webpack_require__(74);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./resources/components/Collab/CollabList.vue?vue&type=template&id=0ccad2e8
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "collab-list", staticClass: "collab-list" },
    _vm._l(_vm.collabs, function(collab) {
      return _c(
        "a",
        {
          key: collab.handle,
          staticClass: "collab-list__item",
          attrs: { href: collab.url }
        },
        [
          _c("span", {
            staticClass: "collab-list__title",
            domProps: { textContent: _vm._s(_vm.sliderTtile(collab)) }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "collab-list__image",
            style: {
              backgroundImage: "url('" + collab.image.cover + "')",
              backgroundPositionY: collab.image.position
            }
          })
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./resources/components/Collab/CollabList.vue?vue&type=template&id=0ccad2e8

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(4);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./resources/utils/helpers/index.js + 4 modules
var helpers = __webpack_require__(0);

// CONCATENATED MODULE: ./resources/mixins/mobile-check.js

/* harmony default export */ var mobile_check = (function () {
  return {
    data: function data() {
      return {
        isMobile: null
      };
    },
    mounted: function mounted() {
      var _this = this;

      helpers["b" /* addMedia */]('(max-width: 768px)', function (mql) {
        var isMobile = mql.matches;
        _this.isMobile = isMobile;
      });
    }
  };
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./resources/components/Collab/CollabList.vue?vue&type=script&lang=js
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var CollabListvue_type_script_lang_js = ({
  mixins: [mobile_check()],
  props: {
    collabs: {
      type: Array,
      required: true
    }
  },
  watch: {
    isMobile: function isMobile(val) {
      val ? this.destroySlick() : this.initSlick();
    }
  },
  mounted: function mounted() {},
  methods: {
    sliderTtile: function sliderTtile(collab) {
      return this.isMobile ? collab.shortName || collab.fullName : collab.fullName;
    },
    initSlick: function initSlick() {
      var slickEl = this.$refs['collab-list'];
      var itemCount = slickEl.querySelectorAll('.collab-list__item').length;
      var maxSlides = itemCount >= 5 ? 5 : itemCount;
      jquery_default()('.collab-list').slick({
        // centerPadding: '60px',
        // centerMode: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: false,
        lazyLoad: 'ondemand',
        responsive: [{
          breakpoint: 992,
          settings: {
            arrows: false,
            centerPadding: '40px',
            slidesToShow: maxSlides
          }
        }, {
          breakpoint: 480,
          settings: {
            arrows: false,
            centerPadding: '40px',
            slidesToShow: maxSlides
          }
        }]
      });
    },
    destroySlick: function destroySlick() {
      var slick = this.$refs['collab-list'].slick;
      slick && slick.destroy();
    }
  }
});
// CONCATENATED MODULE: ./resources/components/Collab/CollabList.vue?vue&type=script&lang=js
 /* harmony default export */ var Collab_CollabListvue_type_script_lang_js = (CollabListvue_type_script_lang_js); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(3);

// CONCATENATED MODULE: ./resources/components/Collab/CollabList.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  Collab_CollabListvue_type_script_lang_js,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "resources/components/Collab/CollabList.vue"
/* harmony default export */ var CollabList = (component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./resources/components/Collab/CollabList.placeholder.vue?vue&type=template&id=4128ba91
var CollabList_placeholdervue_type_template_id_4128ba91_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collab-list" },
    _vm._l(_vm.collabs, function(collab, index) {
      return _c("a", { key: index, staticClass: "collab-list__item" }, [
        _c("div", { staticClass: "collab-list__image placeholder-visible" })
      ])
    }),
    0
  )
}
var CollabList_placeholdervue_type_template_id_4128ba91_staticRenderFns = []
CollabList_placeholdervue_type_template_id_4128ba91_render._withStripped = true


// CONCATENATED MODULE: ./resources/components/Collab/CollabList.placeholder.vue?vue&type=template&id=4128ba91

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.fill.js
var es6_array_fill = __webpack_require__(144);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./resources/components/Collab/CollabList.placeholder.vue?vue&type=script&lang=js

//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var CollabList_placeholdervue_type_script_lang_js = ({
  data: function data() {
    return {
      collabs: new Array(5).fill(0)
    };
  }
});
// CONCATENATED MODULE: ./resources/components/Collab/CollabList.placeholder.vue?vue&type=script&lang=js
 /* harmony default export */ var Collab_CollabList_placeholdervue_type_script_lang_js = (CollabList_placeholdervue_type_script_lang_js); 
// CONCATENATED MODULE: ./resources/components/Collab/CollabList.placeholder.vue





/* normalize component */

var CollabList_placeholder_component = Object(componentNormalizer["a" /* default */])(
  Collab_CollabList_placeholdervue_type_script_lang_js,
  CollabList_placeholdervue_type_template_id_4128ba91_render,
  CollabList_placeholdervue_type_template_id_4128ba91_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var CollabList_placeholder_api; }
CollabList_placeholder_component.options.__file = "resources/components/Collab/CollabList.placeholder.vue"
/* harmony default export */ var CollabList_placeholder = (CollabList_placeholder_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./resources/components/Collab/Collab.vue?vue&type=template&id=b762e864
var Collabvue_type_template_id_b762e864_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collab", class: { "collab--inverse": _vm.inverse } },
    [
      _c("div", { staticClass: "collab__content" }, [
        _c("div", {
          staticClass: "collab__image",
          style: "background-image: url('" + _vm.collab.image.cover + "');"
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "collab__info" },
          [
            _c("div", { staticClass: "collab__description" }, [
              _c(
                "div",
                { staticClass: "collab__name-wrap" },
                [
                  _c("span", {
                    staticClass: "collab__name",
                    domProps: { textContent: _vm._s(_vm.collab.fullName) }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.collab.link, function(link) {
                    return [
                      _c(
                        "a",
                        {
                          key: link.type,
                          staticClass: "collab__link",
                          attrs: { href: link.url, target: "_blank" }
                        },
                        [_c("i", { class: "fa fa-" + link.type })]
                      )
                    ]
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("p", {
                domProps: { textContent: _vm._s(_vm.collab.shortDescription) }
              })
            ]),
            _vm._v(" "),
            _c(
              "kr-button",
              {
                staticClass: "collab__more",
                attrs: { href: "/collections/" + _vm.collab.handle }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("t")("general.btn.view_more")) +
                    "\n      "
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "collab__simple-info" },
          [
            _c("div", { staticClass: "collab__description" }, [
              _c("div", { staticClass: "collab__name-wrap" }, [
                _c("span", {
                  staticClass: "collab__name",
                  domProps: { textContent: _vm._s(_vm.collab.fullName) }
                })
              ]),
              _vm._v(" "),
              _c("p", {
                domProps: { textContent: _vm._s(_vm.collab.shortDescription) }
              })
            ]),
            _vm._v(" "),
            _c(
              "kr-button",
              {
                staticClass: "collab__more",
                attrs: { href: "/collections/" + _vm.collab.handle }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("t")("general.btn.view")) +
                    "\n      "
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "collab__products",
          attrs: { href: "/collections/" + _vm.collab.handle },
          on: {
            mouseover: function($event) {
              _vm.hovered = true
            },
            mouseleave: function($event) {
              _vm.hovered = false
            }
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "scroll-reveal",
                  rawName: "v-scroll-reveal",
                  value: _vm.scrollReveal.productGrid,
                  expression: "scrollReveal.productGrid"
                }
              ],
              staticClass: "product-grid"
            },
            [
              !_vm.isMobile
                ? _vm._l(_vm.collab.products, function(product) {
                    return _c("product-card", {
                      key: product.id,
                      attrs: {
                        product: product,
                        lazy: false,
                        "init-select": _vm.selectProductVariant(),
                        "image-only": ""
                      }
                    })
                  })
                : _vm._l(_vm.collab.products.slice(0, 2), function(product) {
                    return _c("product-card", {
                      key: product.id,
                      attrs: {
                        product: product,
                        lazy: false,
                        "init-select": _vm.selectProductVariant(),
                        "image-only": ""
                      }
                    })
                  })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "collab__title",
              class: { "collab__title--hover": _vm.hovered }
            },
            [
              _c("transition", { attrs: { name: "hover-text" } }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hovered,
                        expression: "hovered"
                      }
                    ],
                    staticClass: "hover-text"
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("t")("general.btn.view_more")) +
                        "\n          "
                    ),
                    _c("arrow-right-icon")
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "collab-title" } }, [
                _c("h2", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.hovered,
                      expression: "!hovered"
                    }
                  ],
                  domProps: { textContent: _vm._s(_vm.collab.title) }
                })
              ])
            ],
            1
          )
        ]
      )
    ]
  )
}
var Collabvue_type_template_id_b762e864_staticRenderFns = []
Collabvue_type_template_id_b762e864_render._withStripped = true


// CONCATENATED MODULE: ./resources/components/Collab/Collab.vue?vue&type=template&id=b762e864

// EXTERNAL MODULE: ./node_modules/bowser/src/bowser.js
var bowser = __webpack_require__(29);
var bowser_default = /*#__PURE__*/__webpack_require__.n(bowser);

// EXTERNAL MODULE: ./resources/components/Shared/index.js + 15 modules
var Shared = __webpack_require__(21);

// EXTERNAL MODULE: ./resources/components/ProductGrid/ProductCard.vue + 9 modules
var ProductCard = __webpack_require__(73);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./resources/icons/arrowRight.vue?vue&type=template&id=53284b60
var arrowRightvue_type_template_id_53284b60_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "icon icon--wide icon-arrow-right",
      attrs: {
        "aria-hidden": "true",
        focusable: "false",
        role: "presentation",
        viewBox: "0 0 20 8"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z",
          fill: "#000",
          "fill-rule": "evenodd"
        }
      })
    ]
  )
}
var arrowRightvue_type_template_id_53284b60_staticRenderFns = []
arrowRightvue_type_template_id_53284b60_render._withStripped = true


// CONCATENATED MODULE: ./resources/icons/arrowRight.vue?vue&type=template&id=53284b60

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./resources/icons/arrowRight.vue?vue&type=script&lang=js
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var arrowRightvue_type_script_lang_js = ({});
// CONCATENATED MODULE: ./resources/icons/arrowRight.vue?vue&type=script&lang=js
 /* harmony default export */ var icons_arrowRightvue_type_script_lang_js = (arrowRightvue_type_script_lang_js); 
// CONCATENATED MODULE: ./resources/icons/arrowRight.vue





/* normalize component */

var arrowRight_component = Object(componentNormalizer["a" /* default */])(
  icons_arrowRightvue_type_script_lang_js,
  arrowRightvue_type_template_id_53284b60_render,
  arrowRightvue_type_template_id_53284b60_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var arrowRight_api; }
arrowRight_component.options.__file = "resources/icons/arrowRight.vue"
/* harmony default export */ var arrowRight = (arrowRight_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./resources/components/Collab/Collab.vue?vue&type=script&lang=js




function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Collabvue_type_script_lang_js = ({
  components: {
    KrButton: Shared["a" /* KrButton */],
    ProductCard: ProductCard["a" /* default */],
    ArrowRightIcon: arrowRight
  },
  props: {
    collab: {
      type: Object,
      required: true
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hovered: false,
      isMobile: bowser_default.a.mobile,
      scrollReveal: {
        productGrid: {
          origin: !this.inverse ? 'left' : 'right',
          duration: 600,
          delay: 300,
          mobile: bowser_default.a.mobile
        }
      }
    };
  },
  computed: {},
  mounted: function mounted() {
    var _this = this;

    helpers["b" /* addMedia */]('(max-width: 768px)', function (mql) {
      var isMobile = mql.matches;
      _this.scrollReveal.productGrid = _objectSpread({}, _this.scrollReveal.productGrid, {
        mobile: isMobile,
        origin: isMobile ? 'top' : !_this.inverse ? 'left' : 'right'
      });
      _this.isMobile = isMobile;
    });
  },
  methods: {
    selectProductVariant: function selectProductVariant() {
      if (this.collab.descriptionJSON) {
        var display = this.collab.descriptionJSON.display;
        return display && display.bumper || 0;
      }

      return 0;
    }
  }
});
// CONCATENATED MODULE: ./resources/components/Collab/Collab.vue?vue&type=script&lang=js
 /* harmony default export */ var Collab_Collabvue_type_script_lang_js = (Collabvue_type_script_lang_js); 
// CONCATENATED MODULE: ./resources/components/Collab/Collab.vue





/* normalize component */

var Collab_component = Object(componentNormalizer["a" /* default */])(
  Collab_Collabvue_type_script_lang_js,
  Collabvue_type_template_id_b762e864_render,
  Collabvue_type_template_id_b762e864_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var Collab_api; }
Collab_component.options.__file = "resources/components/Collab/Collab.vue"
/* harmony default export */ var Collab = (Collab_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./resources/components/Collab/Collab.placeholder.vue?vue&type=template&id=5a5cdcd3
var Collab_placeholdervue_type_template_id_5a5cdcd3_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "collab collab--placeholder",
      class: { "collab--inverse": _vm.inverse }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("a", { staticClass: "collab__products" }, [
        _c(
          "div",
          { staticClass: "product-grid" },
          _vm._l(_vm.placeholderQty, function(i) {
            return _c("div", {
              key: "placeholder" + i,
              staticClass: "product placeholder-visible"
            })
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "collab__title" })
      ])
    ]
  )
}
var Collab_placeholdervue_type_template_id_5a5cdcd3_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "collab__content" }, [
      _c("div", { staticClass: "collab__image placeholder-visible" }),
      _vm._v(" "),
      _c("div", { staticClass: "collab__info" }, [
        _c("div", { staticClass: "collab__description" }, [
          _c("div", { staticClass: "collab__name-wrap" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "collab__simple-info" }, [_c("h2")])
    ])
  }
]
Collab_placeholdervue_type_template_id_5a5cdcd3_render._withStripped = true


// CONCATENATED MODULE: ./resources/components/Collab/Collab.placeholder.vue?vue&type=template&id=5a5cdcd3

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./resources/components/Collab/Collab.placeholder.vue?vue&type=script&lang=js
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Collab_placeholdervue_type_script_lang_js = ({
  props: {
    inverse: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hovered: false,
      isMobile: false
    };
  },
  computed: {
    placeholderQty: function placeholderQty() {
      return this.isMobile ? 2 : 4;
    }
  },
  mounted: function mounted() {
    var _this = this;

    helpers["b" /* addMedia */]('(max-width: 768px)', function (mql) {
      var isMobile = mql.matches;
      _this.isMobile = isMobile;
    });
  }
});
// CONCATENATED MODULE: ./resources/components/Collab/Collab.placeholder.vue?vue&type=script&lang=js
 /* harmony default export */ var Collab_Collab_placeholdervue_type_script_lang_js = (Collab_placeholdervue_type_script_lang_js); 
// CONCATENATED MODULE: ./resources/components/Collab/Collab.placeholder.vue





/* normalize component */

var Collab_placeholder_component = Object(componentNormalizer["a" /* default */])(
  Collab_Collab_placeholdervue_type_script_lang_js,
  Collab_placeholdervue_type_template_id_5a5cdcd3_render,
  Collab_placeholdervue_type_template_id_5a5cdcd3_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var Collab_placeholder_api; }
Collab_placeholder_component.options.__file = "resources/components/Collab/Collab.placeholder.vue"
/* harmony default export */ var Collab_placeholder = (Collab_placeholder_component.exports);
// CONCATENATED MODULE: ./resources/components/Collab/index.js




// EXTERNAL MODULE: ./resources/constants/liquid-data.js
var liquid_data = __webpack_require__(2);

// EXTERNAL MODULE: ./resources/apis/product.js + 6 modules
var product = __webpack_require__(11);

// EXTERNAL MODULE: ./resources/stores/index.js + 1 modules
var stores = __webpack_require__(19);

// CONCATENATED MODULE: ./resources/stores/collab/getters.js
function currentDeviceHandle(state) {
  return state.device;
}
function currentDeviceColor(state, getters, rootState) {
  return state.display.deviceColor || 'Silver';
}
// CONCATENATED MODULE: ./resources/stores/collab/mutations.js
function setBackplates(state, data) {
  state.backplates = data;
}
function setBumpers(state, data) {
  state.bumpers = data;
}
// EXTERNAL MODULE: ./resources/utils/db/index.js + 2 modules
var db = __webpack_require__(47);

// EXTERNAL MODULE: ./resources/models/index.js + 7 modules
var models = __webpack_require__(18);

// CONCATENATED MODULE: ./resources/stores/collab/index.js




var collab_db = new db["a" /* Db */]();
collab_db.addModel('Device', models["c" /* Device */]);
collab_db.addModel('DeviceColor', models["d" /* DeviceColor */]);
var state = {
  deviceColor: null,
  bumpers: [],
  backplates: [],
  display: {
    device: 'iphone-11-pro-max OR iphone-xs',
    deviceColor: 'Silver',
    bumper: 0
  }
};
/* harmony default export */ var collab = ({
  namespaced: true,
  state: state,
  getters: getters_namespaceObject,
  mutations: mutations_namespaceObject,
  db: collab_db
});
// EXTERNAL MODULE: ./node_modules/vue-lazyload/vue-lazyload.js
var vue_lazyload = __webpack_require__(72);
var vue_lazyload_default = /*#__PURE__*/__webpack_require__.n(vue_lazyload);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(5);

// CONCATENATED MODULE: ./resources/pages/page.collab.js









function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }

function page_collab_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { page_collab_defineProperty(target, key, source[key]); }); } return target; }

function page_collab_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var database = Object(db["b" /* install */])(collab.db);
vue_esm["default"].use(vue_lazyload_default.a, {
  dispatchEvent: true,
  observer: true,
  observerOptions: {
    rootMargin: '200px 0px'
  }
});
vue_esm["default"].use(database.plugin);
stores["a" /* default */].registerModule('collab', collab);
stores["a" /* default */].registerModule('db', database.module);
new vue_esm["default"]({
  store: stores["a" /* default */],
  el: '.collab-wrap',
  provide: function provide() {
    return {
      settings: {
        product_image_size: '250x'
      }
    };
  },
  components: {
    PageNav: PageNav["a" /* default */],
    CollabList: CollabList,
    CollabListPlaceholder: CollabList_placeholder,
    Collab: Collab,
    CollabPlaceholder: Collab_placeholder
  },
  data: function data() {
    var collections = liquid_data["a" /* default */].collections;
    return {
      collections: collections,
      collabs: [],
      navActive: collections.findIndex(function (c) {
        return c.handle === 'collab';
      }),
      loading: false
    };
  },
  computed: page_collab_objectSpread({}, Object(vuex_esm["e" /* mapState */])('collab', ['display'])),
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.next = 3;
              return this.fetchData();

            case 3:
              this.collabs = liquid_data["a" /* default */].collabs;
              this.loading = false;

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function created() {
      return _created.apply(this, arguments);
    };
  }(),
  methods: page_collab_objectSpread({}, Object(vuex_esm["d" /* mapMutations */])('collab', ['setBumpers', 'setBackplates']), {
    /**
     * Get data from remote
     */
    fetchData: function () {
      var _fetchData = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var devices, _ref, _ref2, backplates, bumpers;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return product["e" /* getDevices */]();

              case 3:
                devices = _context2.sent;
                this.$db.Device.insert(devices);
                _context2.next = 7;
                return Promise.all([product["b" /* getBackplates */]({
                  device: this.display.device
                }), product["c" /* getBumpers */]({
                  device: this.display.device
                })]);

              case 7:
                _ref = _context2.sent;
                _ref2 = _slicedToArray(_ref, 2);
                backplates = _ref2[0];
                bumpers = _ref2[1];
                this.setBackplates(backplates.data);
                this.setBumpers(bumpers.data);
                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](0);
                console.error(_context2.t0);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 15]]);
      }));

      return function fetchData() {
        return _fetchData.apply(this, arguments);
      };
    }()
  })
});

/***/ })

/******/ });